import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from "react-redux";
import { Grid } from '@mui/material';
import { Select, Button } from 'Components';
import { NotificationManager } from 'Components/Notifications';
import { Alert } from '@mui/material';


import {
    getMealBreakSetting,
    createBreakSettings,
    clearRedux
} from 'Redux/actions';

import { catalogLoad } from 'Redux/actions';
import './index.scss';

const MealBreakNotifications = (props) => {

    const { messages } = useIntl();

    const optionsAction = [{
        id: '0',
        name: messages['None']
    }, {
        id: '30',
        name: `30 ${messages['fsm_settings_break_mins']}`
    }, {
        id: '45',
        name: `45 ${messages['fsm_settings_break_mins']}`
    },
    {
        id: '60',
        name: `60 ${messages['fsm_settings_break_mins']}`
    },
    {
        id: '120',
        name: `120 ${messages['fsm_settings_break_mins']}`
    }];

    const optionsNotify = [{
        id: '0',
        name: messages['unit_jbusNotSet']
    }, {
        id: '120',
        name: `2 ${messages['reportsMainRT_hours']}`
    },
    {
        id: '180',
        name: `3 ${messages['reportsMainRT_hours']}`
    },
    {
        id: '240',
        name: `4 ${messages['reportsMainRT_hours']}`
    },
    {
        id: '300',
        name: `5 ${messages['reportsMainRT_hours']}`
    },
    {
        id: '360',
        name: `6 ${messages['reportsMainRT_hours']}`
    },
    {
        id: '420',
        name: `7 ${messages['reportsMainRT_hours']}`
    },
    {
        id: '480',
        name: `8 ${messages['reportsMainRT_hours']}`
    },
    {
        id: '540',
        name: `9 ${messages['reportsMainRT_hours']}`
    },
    {
        id: '600',
        name: `10 ${messages['reportsMainRT_hours']}`
    }];

    const [formData, setFormData] = useState({ contacts: [], breakDuration: optionsAction[0], notifyAt: optionsNotify[0] });
    const [error, setError] = useState('');
    const dispatch = useDispatch()
    const contacts = useSelector((state) => state.catalogsRedux.contacts)
    const loadingContacts = useSelector((state) => state.catalogsRedux.loadingContacts)
    const { mealBreak, response, loadingMealBreak, loadingCreateEdit } = useSelector((state) => state.mealBreakNotificationsRedux)

    useEffect(() => {
        dispatch(catalogLoad(['contacts']));
        dispatch(getMealBreakSetting());
    }, [])

    useEffect(() => {
        if (mealBreak?.break) {
            let notifyAt = optionsNotify.filter(d => d.id == mealBreak?.break?.notifyAt)[0];
            let breakDuration = optionsAction.filter(d => d.id == mealBreak?.break?.breakDuration)[0];
            let contactsNew = contacts.filter(d => mealBreak?.break?.contacts?.includes(d.id));
            setFormData({ ...formData, notifyAt, breakDuration, contacts: contactsNew })
        }
    }, [mealBreak])

    useEffect(() => {
        if (response?.create) {
            NotificationManager.success(
                messages['FSM_SETTINGS_TIME_CARD_meal_break_success'],
                messages['success'],
                3000,
                null,
                null,
                'Success',
            );

            dispatch(clearRedux("FSM_SETTINGS_MEAL_BREAK", { response: {} }));
            setError('');
        }
    }, [response])

    const sendDataBreak = () => {
        if (formData?.notifyAt?.id !== '0' && formData?.contacts?.length === 0) {
            setError(messages['fsm_settings_break_error_contacts']);
        } else if (formData?.contacts && formData?.contacts?.length > 0 && formData?.notifyAt?.id == '0') {
            setError(messages['fsm_settings_break_error_notify']);
        }
        else {
            setError('');
            dispatch(createBreakSettings(formData));
        }
    }


    return (
        <Grid container spacing={0} className="mealBreakContainer">
            <Grid item sm={12}>
                {
                    error &&
                    <Alert severity="error">{error}</Alert>
                }
            </Grid>
            <Grid item sm={12}>
                <Select
                    id="notifyAt"
                    label={messages['fsm_settings_break_notifyAt']}
                    value={formData.notifyAt}
                    onChange={(value) => setFormData({ ...formData, notifyAt: value })}
                    options={optionsNotify}
                    textField="name"
                    valueField="id"
                    menuPlacement="auto"
                />
            </Grid>
            <Grid item sm={12}>
                <Select
                    id="breakDuration"
                    label={messages['fsm_settings_break_breakDuration']}
                    value={formData.breakDuration}
                    onChange={(value) => setFormData({ ...formData, breakDuration: value })}
                    options={optionsAction}
                    textField="name"
                    valueField="id"
                />
            </Grid>
            <Grid item sm={12} className="mealBreakSubscribers">
                <Select
                    id="selectSubscribers"
                    label={messages['fsm_settings_break_contacts']}
                    value={formData?.contacts || []}
                    onChange={(value) => {
                        setFormData({ ...formData, contacts: value || [] })
                    }}
                    options={contacts}
                    textField="title"
                    valueField="id"
                    placeholder={messages['fsm_settings_break_contacts']}
                    isClearable
                    selectedOptionsBelow
                    multiple
                    loading={loadingContacts}
                />
            </Grid>
            <Grid item sm={12} style={{bottom:80,position: 'absolute'}}>
                <Button
                    className="btn-blue"
                    disabled={loadingMealBreak || loadingCreateEdit}
                    onClick={sendDataBreak}
                >
                    {messages['save']}
                </Button>
            </Grid>
        </Grid>
    );
}

export default MealBreakNotifications;